import React, { useState, useEffect, useCallback } from 'react';
import useMouseParallax from '../hooks/useMouseParallax';

const FULL_TEXT = 'Every great thing starts with 200 OK.';

const Hero = () => {
  const [displayText, setDisplayText] = useState('');
  const mouse = useMouseParallax();

  const typeText = useCallback(() => {
    let i = 0;
    const interval = setInterval(() => {
      if (i < FULL_TEXT.length) {
        setDisplayText(FULL_TEXT.slice(0, i + 1));
        i++;
      } else {
        clearInterval(interval);
      }
    }, 45);
    return interval;
  }, []);

  useEffect(() => {
    const startDelay = setTimeout(() => {
      const interval = typeText();
      return () => clearInterval(interval);
    }, 2000);
    return () => clearTimeout(startDelay);
  }, [typeText]);

  // Generate particles
  const particles = Array.from({ length: 30 }, (_, i) => ({
    id: i,
    left: `${Math.random() * 100}%`,
    size: `${2 + Math.random() * 4}px`,
    duration: `${15 + Math.random() * 20}s`,
    delay: `${Math.random() * 15}s`,
    opacity: 0.2 + Math.random() * 0.4,
  }));

  // Mouse parallax calculations
  const orb1X = mouse.x * 60;
  const orb1Y = mouse.y * 60;
  const orb2X = mouse.x * -30;
  const orb2Y = mouse.y * -30;
  const titleShiftX = mouse.x * 8;
  const titleShiftY = mouse.y * 5;
  const subtitleShiftX = mouse.x * 4;
  const subtitleShiftY = mouse.y * 3;

  return (
    <section className="hero" id="hero">
      <div className="hero__bg-gradient"></div>

      {/* Floating magnetic orbs */}
      <div
        className="hero__orb hero__orb--1"
        style={{ transform: `translate(${orb1X}px, ${orb1Y}px)` }}
      />
      <div
        className="hero__orb hero__orb--2"
        style={{ transform: `translate(${orb2X}px, ${orb2Y}px)` }}
      />
      <div
        className="hero__orb hero__orb--3"
        style={{ transform: `translate(${mouse.x * 20}px, ${mouse.y * 20}px)` }}
      />

      {/* Floating particles */}
      <div className="hero__particles">
        {particles.map((p) => (
          <div
            key={p.id}
            className="particle"
            style={{
              left: p.left,
              width: p.size,
              height: p.size,
              animationDuration: p.duration,
              animationDelay: p.delay,
              opacity: p.opacity,
            }}
          />
        ))}
      </div>

      <div className="hero__content">
        <div className="hero__label">
          <span className="hero__label-dot"></span>
          {'// STATUS: LOADING'}
        </div>

        <h1
          className="hero__title"
          style={{
            transform: `translate(${titleShiftX}px, ${titleShiftY}px)`,
          }}
        >
          {displayText}
          <span className="typing-cursor"></span>
        </h1>

        <p
          className="hero__subtitle"
          style={{
            transform: `translate(${subtitleShiftX}px, ${subtitleShiftY}px)`,
          }}
        >
          We're building something the digital economy has been missing.
          It's almost ready.
        </p>

        <p className="hero__supporting">
          200 OK Studios is a technology company based in Accra, Ghana ,
          engineering tools that make digital work faster, smarter, and more
          reliable for everyone involved.
        </p>

        <div className="hero__actions">
          <a href="#waitlist" className="btn btn--primary btn--magnetic">
            Join the Waitlist, Be First In
            <span className="material-symbols-outlined">arrow_forward</span>
          </a>
        </div>

        <p className="hero__disclaimer">
          No spam. Just the launch announcement when we're ready.
        </p>
      </div>
    </section>
  );
};

export default Hero;
